import { EntryImage } from './entry-image';
import { IRawEntry } from './entry.service';

export enum JurorSelection {
    NotYetRated,
    FirstImage,
    SecondImage,
    NeitherImage
}

export class Entry {
    raw: any;

    submissionID: string;
    numEntries: number;
    entryImage1: EntryImage;
    entryImage2: EntryImage;

    jurorSelection = JurorSelection.NotYetRated;
}
